<template>
  <div>
    <div class="content">
      <h1>What is AIDrugDesigner?</h1>
      <p>
          AIDrugDesigner is a web-based platform for the de novo design and optimization of
          small molecules using deep learning models. It aims to facilitate AI-driven drug
          discovery through an accessible graphical interface without requiring programming
          expertise. The platform comprises two modules: Generation and Optimization. The
          Generation module supports target-aware molecular design, pharmacophore-guided
          generation, property-controlled molecular design, and linker design.
          The Optimization module refines existing molecules by improving key drug-like
          properties, including QED, LogP, and synthetic accessibility (SA).
      </p>
    </div>
    <br>
    <div class="content">
      <h1>How does AIDrugDesigner work?</h1>
      <el-row :gutter="5">
        <el-col :span="11">
          <p>
              AIDrugDesigner integrates multiple deep learning–based generative and
              optimization models within a unified web framework. For target-guided design,
              the platform combines SBDD-3D(Li, et al., 2021) with automatic pocket detection
              using Fpocket (Le Guilloux, et al., 2009) for structure-guided molecular
              generation, and incorporates EncDecLM(Uludogan, et al., 2022) for
              sequence-based design. In addition, it includes PGMG(Zhu, et al., 2023)
              for pharmacophore-constrained generation, cRNN(Kotsias, et al., 2020)
              for property-controlled design, and DEVELOP(Imrie, et al., 2021) for
              linker generation. For lead optimization, we implemented the
              Modof(Chen, et al., 2021) framework and retrained task-specific models to
              improve selected molecular properties, enabling flexible refinement of
              user-provided compounds. Users submit task-specific inputs through a
              graphical interface, and the corresponding model is automatically executed.
              Detailed tutorials describing input formats and parameters are provided for
              each design mode. After submission, a unique results ID is generated to
              retrieve results via an interactive visualization page, and downloadable
              files containing generated structures and associated property predictions
              are provided.
          </p>
        </el-col>
        <el-col :span="13">
          <el-image src="https://www.csuligroup.com/AIDrugDesigner/img/home.jpg" style="width: 101%;"></el-image>
        </el-col>
      </el-row>
    </div>

    <br>
    <div class="content" style="line-height: 1;">
      <h2>Reference</h2>
      <p style="line-height: 1;">1. Li, Y., Pei, J. and Lai, L. Structure-based de novo drug design using 3D deep generative models.
          Chemical Science 2021;12(41):13664-13675.</p>
      <p style="line-height: 1;">2. Le Guilloux, V., Schmidtke, P. and Tuffery, P. Fpocket: an open source platform for ligand pocket
          detection. BMC bioinformatics 2009;10(1):168.</p>
      <p style="line-height: 0.9;">3. Uludogan, G., et al. Exploiting pretrained biochemical language models for targeted
          drug design. Bioinformatics 2022;38:ii155-ii161.</p>
      <p style="line-height: 1;">4. Zhu, H., et al. A pharmacophore-guided deep learning approach for bioactive molecular generation.
          Nature Communications 2023;14(1):6234.</p>
      <p style="line-height: 1;">5. Kotsias, P.-C., et al. Direct steering of de novo molecular generation with descriptor
          conditional recurrent neural networks. Nature Machine Intelligence 2020;2(5):254-265.
      </p>
      <p style="line-height: 0.9;">
          6. Imrie, F., et al. Deep generative design with 3D pharmacophoric constraints.
          Chemical science 2021;12(43):14577-14589.
      </p>
      <p style="line-height: 1;">7. Chen, Z., et al. A deep generative model for molecule optimization via one fragment
          modification. Nature Machine Intelligence 2021;3(12):1040-1049.</p>
    </div>

  </div>

</template>

<script>
export default {
  name: "Home"
}
</script>

<style scoped>
  p{
    line-height: 1.5em;
  }
div {
  min-height: 100%;
  text-align: left;
  max-width: 1140px;
  margin: 0 auto;
}
  .content{
    box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
    background-color: RGB(255,255,255);
    border-radius: 10px;
    padding: 10px;

  }
</style>
